export default __webpack_public_path__ + "static/media/contributors.d914d971.png";